import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

// Get editorial page IDs from config or use defaults
const getEditorialPageIds = config => {
  // Check if config has editorial page IDs defined
  const configuredIds = config?.layout?.editorialsPage?.pageIds;

  if (
    configuredIds &&
    Array.isArray(configuredIds) &&
    configuredIds.length > 0
  ) {
    return configuredIds;
  }

  // Default editorial page IDs as fallback
  return [
    '20250607_home-for-icons_press',
    '20250616_loose-ends-004_editorial',
    '20250603_loose-ends-003_editorial',
    '20250602_loose-ends-002_editorial',
    '20250420_loose-ends-001_editorial',
    '20250502_scandinavian-mind_external',
  ];
};

export const loadData = (params, search, config) => dispatch => {
  const editorialPageIds = getEditorialPageIds(config);

  // Create an object mapping each page ID to its asset path
  const pageAssets = editorialPageIds.reduce((assets, pageId) => {
    return {
      ...assets,
      [pageId]: `content/pages/${pageId}.json`,
    };
  }, {});

  // Fetch all editorial pages at once
  // Set hasFallbackContent to true since we want to handle missing pages gracefully
  return dispatch(fetchPageAssets(pageAssets, true));
};
